export default "__VITE_ASSET__zPrSFUa0__"